class ctxTableTreeviewNodeDirective {
    constructor(ivhTreeviewCompiler) {
        this.ivhTreeviewCompiler = ivhTreeviewCompiler;
        this.restrict = 'A';
        this.scope = {
            node: '=ctxTableTreeviewNode',
            depth: '=ctxTableTreeviewDepth'
        };
        this.require = '^ctxTableTreeview';
    }

    compile(tElement) {
        return this.ivhTreeviewCompiler
            .compile(tElement, (scope, element, attrs, trvw) => {
                let node = scope.node;

                let getChildren = scope.getChildren = function () {
                    return trvw.children(node);
                };

                let getNodeLevel = scope.getNodeLevel = function () {
                    return trvw.getNodeLevel(node);
                };

                scope.trvw = trvw;
                scope.childDepth = scope.depth + 1;

                if (!trvw.isExpanded(node)) {
                    trvw.expand(node, trvw.isInitiallyExpanded(scope.depth));
                }

                scope.$watch(() => getChildren().length > 0, (newVal) => {
                    if (newVal) {
                        element.removeClass('ivh-treeview-node-leaf');
                    } else {
                        element.addClass('ivh-treeview-node-leaf');
                    }
                });
            });
    }

    static directiveFactory(ivhTreeviewCompiler) {
        return new ctxTableTreeviewNodeDirective(ivhTreeviewCompiler);
    }
}

ctxTableTreeviewNodeDirective.directiveFactory.$inject = ['ivhTreeviewCompiler'];

module.exports = ctxTableTreeviewNodeDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxTableTree/customDirectives/ctxTableTreeviewNode.directive.js